module.exports = __webpack_public_path__ + "waxjet-510-2.png?546810c1c6fb72a9df2586806b02116f";